module.exports = __webpack_public_path__ + "img/en.2cde6460.svg";